// Shared scorecard helpers — used by the consultant Home dashboard and the client dashboard.

// Level badge colours now live in config/theme --> single source for all colours
export { LEVEL_COLOURS } from '../config/theme';

// Thresholds come from the backend (combined-total), sorted highest first

export const nextLevel = (points, thresholds = []) => {
  for (let i = thresholds.length -1; i >= 0; i-= 1) {
    if (points < thresholds[i].min) return { needed: thresholds[i].min - points, label: thresholds[i].label };
  }
  return null;
};

// Max points for an element = sum of its indicator max points.
export const maxPointsFromIndicators = (indicators = []) =>
  indicators.reduce((s, ind) => s + (ind.points || 0), 0);

// Derive sub-minimum status from a get_scorecard response.
export const subMinFromScorecard = (data) => {
  const totalSubMin = data.results?.find((r) => r.id === '_total_sub_min');
  return data.sub_minimum_met ?? totalSubMin?.sub_minimum_met ?? null;
};

// Normalise a get_scorecard response into { points, maxPoints, subMinimumMet }.
export const normaliseScorecard = (data) => {
  if (data?.total_points == null) return null;
  return {
    points: data.total_points,
    maxPoints: maxPointsFromIndicators(data.indicators),
    subMinimumMet: subMinFromScorecard(data),
  };
};

// Combine per-key scores (keyed by backend element key) into one summary.
// Entries with multiple elementKeys (e.g. Enterprise & Supplier Development) get summed.
export const aggregateScore = (scores, elementKeys) => {
  const parts = (elementKeys || []).map((k) => scores[k]).filter(Boolean);
  if (parts.length === 0) return null;
  return {
    points: parts.reduce((sum, p) => sum + p.points, 0),
    maxPoints: parts.reduce((sum, p) => sum + p.maxPoints, 0),
    subMinimumMet: parts.every((p) => p.subMinimumMet !== false),
  };
};
